import React from "react";
import "./index.module.scss";
import Scroller from "../../components/Scroller";

export default () => {
  return <Scroller>test</Scroller>;
};
